import type { ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'

/** The document page's frame: its title line over the pages, the analysis panel beside them. */
export function SubscriptionUnderwritingDocumentPageSkeleton(): ReactElement {
  return (
    <PharaohNextScope surface="bo">
      <div aria-busy className="flex h-screen min-h-0 flex-col">
        <header
          className="
            flex min-h-[64px] shrink-0 items-center gap-50 border-b border-solid border-line-base-basic
            bg-surface-base-normal px-60 py-50
          "
        >
          <Skeleton width={32} height={32} />
          <Skeleton variant="text" width={240} />
          <Skeleton width={96} height={24} />
          <Skeleton className="ml-auto" width={136} height={32} />
        </header>
        <div className="flex min-h-0 flex-1">
          <div className="flex min-w-0 flex-1 bg-surface-base-normal p-60">
            <Skeleton className="flex-1" />
          </div>
          <div
            className="
              flex w-[503px] max-w-[45%] shrink-0 flex-col gap-40 border-l border-solid border-line-base-basic p-60
            "
          >
            <Skeleton variant="text" width={160} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </div>
        </div>
      </div>
    </PharaohNextScope>
  )
}
